import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import {
  CODETABLE_TYP_KIDS_TERMIN_BEARBEITUNGS_STATUS,
  CODETABLE_TYP_KIDS_TERMIN_STATUS,
  CODETABLE_TYP_KIDS_TERMIN_TYP,
  codetableListToOptions,
  ICodetableItem
} from '@mng/mgs-lib';
import { computed, inject } from '@angular/core';
import { MgsWebApi } from '../mgs-webapi.service';
import { firstValueFrom } from 'rxjs';

export type KidsItemTyp =
  | typeof CODETABLE_TYP_KIDS_TERMIN_TYP
  | typeof CODETABLE_TYP_KIDS_TERMIN_BEARBEITUNGS_STATUS
  | typeof CODETABLE_TYP_KIDS_TERMIN_STATUS;

export interface IKidsCodetableState {
  itemObject?: { [type: string]: ICodetableItem[] };
}

export const KidsCodetableStore = signalStore(
  { providedIn: 'root' },

  withState<IKidsCodetableState>({ itemObject: undefined }),
  withComputed((state) => ({
    kidsTerminTypOptions: computed(() => codetableListToOptions(state.itemObject()[CODETABLE_TYP_KIDS_TERMIN_TYP])),
    kidsTerminBearbeitungsStatusOptions: computed(() =>
      codetableListToOptions(state.itemObject()[CODETABLE_TYP_KIDS_TERMIN_BEARBEITUNGS_STATUS])
    ),
    kidsTerminStatusOptions: computed(() =>
      codetableListToOptions(state.itemObject()[CODETABLE_TYP_KIDS_TERMIN_STATUS])
    ),
    kidsTerminStatusObjectValueOptions: computed(() =>
      codetableListToOptions(state.itemObject()[CODETABLE_TYP_KIDS_TERMIN_STATUS], false, 'object')
    )
  })),
  withMethods((state) => {
    const webApi = inject(MgsWebApi);

    return {
      load: async () => {
        if (!state.itemObject()) {
          const itemObject = await firstValueFrom(webApi.codetableEntries('Kids'));
          patchState(state, { itemObject });
        }
      },
      update: (daten: IKidsCodetableState) => patchState(state, daten)
    };
  })
);

export type KidsCodetableStore = InstanceType<typeof KidsCodetableStore>;
